import { useState, useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedCourses from './components/FeaturedCourses';
import CategoriesSection from './components/CategoriesSection';
import WhyLearnFlow from './components/WhyLearnFlow';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';
import { getHomeContentApi } from '../../api/apiServices';

export default function HomePage() {
  const [cmsContent, setCmsContent] = useState(null);

  useEffect(() => {
    getHomeContentApi()
      .then(res => {
        if (res && res.data) setCmsContent(res.data);
      })
      .catch(err => {
        console.warn("Could not load dynamic home content, using defaults:", err.message);
      });
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection content={cmsContent?.hero} />
      <FeaturedCourses />
      <CategoriesSection />
      <WhyLearnFlow content={cmsContent?.whyUs} />
      <Testimonials content={cmsContent?.testimonials} />
      <CTASection content={cmsContent?.ctaBanner} />
      <Footer />
    </div>
  );
}

